import notfound from '../../../Assets/images/il-empty.svg';
import { Form, Formik } from 'formik';
import React, { useEffect, useRef, useState } from "react";
import SelectCheckField from "../../../Components/SelectCheckField/SelectCheckField";
import RangeDatePicker from "../../../Components/RangeDatePicker/RangeDatePicker";
import Button from '../../../Components/Button/Button';
import { OverlayTrigger } from "react-bootstrap";
import { Tooltip } from "react-bootstrap";
import { usePagination, useSortBy, useTable} from 'react-table';
import { EnvioInformePrellenado } from '../Services/EnvioInformePrellenado';
import PaginationComponent from '../../../Components/PaginationTableServer/PaginationTableServer';
import ModalMacroubicaciones from './ModalMacroubicaciones';
import ModalDescargarArchivo from './ModalDescargarArchivo';
import useLogin from '../../Autenticacion/Hooks/useLogin';
import moment from 'moment';
import { EliminarPlan } from '../Services/EliminarPlan';
import { useToast } from '../../../Hooks/useToast';

const PlanificarTable = ({columns, data, fetchData, pageCount: controlledPageCount, currentpage, pageSize: controlledPageSize, sortBy: controlledSortBy, setPagination, handleShowAgregarPlan, setDatosModal, setEditar, indicadoresExigencia, fechaHoy, setExistenFechasCargas}) => {
	const formikref = useRef();
	const [showModalMacroubicaciones, setShowModalMacroubicaciones] = useState(false);
	const [showModalDescargarArchivo, setShowModalDescargarArchivo] = useState(false);
	const [indicadorSeleccionado, setIndicadorSeleccionado] = useState(-1);
	const [exigenciaSeleccionada, setExigenciaSeleccionada] = useState(-1);
	const [datosModalMacro, setDatosModalMacro] = useState();
	const [exigencias, setExigencias] = useState([]);
	const [datos, setDatos] = useState([]);
	const [indicadores, setIndicadores] = useState([]);
	const [botonDescarga, setBotonDescarga] = useState(null);
	const [mensajeRespuesta,setMensajeRespuesta] = useState([]);
	const [eliminar, setEliminar] = useState(false);
	const [fechaSleccionada, setFechaSleccionada] = useState([moment().subtract(1, 'M').toDate(), new Date()]);
	const addToast = useToast();
	const { usuario } = useLogin();

	const handleShow = (row) => {
		setShowModalMacroubicaciones(true);
		setDatosModalMacro(row);
	}

	const handleClose = () => {
		setShowModalMacroubicaciones(false)
		setShowModalDescargarArchivo(false)
	}
	
	const AgregarPlanificacion = () => {
		setEditar(false);
		handleShowAgregarPlan();
	}

	const [initialValues, setInitialValues] = useState({
		indicador: indicadorSeleccionado,
		exigencia: exigenciaSeleccionada,
		periodo: fechaSleccionada
	});

	const {getTableProps, getTableBodyProps, headerGroups, prepareRow, page, pageCount, gotoPage, setSortBy, state: { pageIndex, pageSize, sortBy }} 
	= useTable(
		{
			columns
			, data
			, initialState: { pageIndex: currentpage, pageSize: controlledPageSize, sortBy: controlledSortBy }
			, manualPagination: true
			, pageCount: controlledPageCount
			, autoResetPage: false
			, autoResetSortBy: false
			, manualSortBy: true
		},
		useSortBy
		, usePagination
	)

	const [valoresFormularioEnvio, setValoresFormularioEnvio] = useState({
		paginacion: {
			numeroPagina: pageIndex
			, cantidadRegistros: pageSize
			, orderByAscending: false
			, ordenadoPor: "fechaPlanificada"
		},
		datosBusqueda: {
			idUsuario: usuario.id
			, indicadorId: indicadorSeleccionado
			, exigenciaId: exigenciaSeleccionada
			, fechaInicio: moment().subtract(1, 'M').format()
			, fechaFin: moment().format()
		}
	});

	const editarPlanificacion = (file, existeFechaCarga) => {
		setEditar(true);
		setExistenFechasCargas(existeFechaCarga);
		setDatosModal(file);
	}

	const EliminarPlanificacion = (values) => {
		fecthEliminarPlan(values);
	}

	const handleButtonClick = (file) => {
		setBotonDescarga(false);
		setDatos(file);
	};

	function BuscarEventosConcesion(values) {
		let formEnvio = valoresFormularioEnvio;
		formEnvio.paginacion.numeroPagina = 0;
		formEnvio.paginacion.orderByAscending = false;
		formEnvio.paginacion.ordenadoPor = "fechaPlanificada";

		formEnvio.datosBusqueda.idUsuario = usuario.id;
		formEnvio.datosBusqueda.indicadorId = values.indicador;
		formEnvio.datosBusqueda.exigenciaId = values.exigencia;
		formEnvio.datosBusqueda.fechaInicio = values.periodo[0];
		formEnvio.datosBusqueda.fechaFin = values.periodo[1];

		const fetchData = async () => {
			await Promise.all([
				setValoresFormularioEnvio(formEnvio),
			]);
		};

		fetchData();
		setPagination({
			pageIndex: formEnvio.paginacion.numeroPagina,
			pageSize: formEnvio.paginacion.cantidadRegistros,
			sortBy: []
		});

		setSortBy([]);
		gotoPage(0);
	};

	const filtroExigencia = () => {
		let listaExigencias = indicadoresExigencia;

		if(indicadorSeleccionado !== -1){
			listaExigencias = indicadoresExigencia
			.filter(item => item.indicadorId === indicadorSeleccionado)[0].exigencias
			.map(item => ({
				value: item.id,
				label: `${item.sigla} - ${item.descripcion}`
			}))
		}
		else{
			listaExigencias = indicadoresExigencia
			.flatMap(item => item.exigencias.map(ex => ({
				value: ex.id,
				label: `${item.sigla} - ${ex.sigla} - ${ex.descripcion}`
			})))
		}

		listaExigencias = [{ value: -1, label: 'Todos' }, ...listaExigencias];
		setExigencias(listaExigencias)
	}

	const filtroIndicador = () => {
		const listaIndicadores = [
			{ value: -1, label: 'Todos' },
			...indicadoresExigencia.map(item => ({
				value: item.indicadorId,
				label: item.sigla
			}))
		];
	
		setIndicadores(listaIndicadores);
	};

	async function fecthEliminarPlan(values) {
		const usuarioId = {
			idUsuario: usuario.id,
			planConservacionId: values.planConservacionId
		};
		try {
			const response = await EliminarPlan(usuarioId);
			if (response && response.status === 200 && response.data) {
				addToast({ mostrar: true, mensaje: "Plan Eliminado Correctamente", titulo: 'Información', tipo: 'Info' });
				setEliminar(true);
			}
		} catch (error) {
			console.error("Error obteniendo indicadores:", error);
		}
	}

	async function fecthInformePrellenado() {
		const usuarioId = {
			idUsuario: usuario.id,
			planConservacionId: datos.planConservacionId ?? 1
		};

		try {
			const response = await EnvioInformePrellenado(usuarioId);
			if (response && response.status === 200 && response.data) {
				setMensajeRespuesta(response.data);
				setShowModalDescargarArchivo(true);
			}
		} catch (error) {
			console.error("Error obteniendo indicadores:", error);
		}
	}

	useEffect(() => {
		setInitialValues((prev) => ({
			...prev,
			indicador: indicadorSeleccionado,
			exigencia: exigenciaSeleccionada
		}));
		filtroIndicador();
		filtroExigencia();
	}, [indicadorSeleccionado, exigenciaSeleccionada, indicadoresExigencia]);

	useEffect(() => {
		setInitialValues((prev) => ({
			...prev,
			periodo: fechaSleccionada
		}));
	}, [fechaSleccionada]);

	useEffect(() => {
		if (valoresFormularioEnvio.datosBusqueda.indicadorId >= -1) {
			fetchData({ formulario: valoresFormularioEnvio, pageIndex, sortBy });
			setPagination(values => ({
				...values,
				sortBy: sortBy
			}));
			setEliminar(false)
		}
	}, [pageIndex, sortBy, eliminar]);

	useEffect(() => {
		if(botonDescarga === false)
		{
			fecthInformePrellenado();
			setBotonDescarga(true);
		}
	}, [botonDescarga]);

	return (
		<div>
			<div className="d-flex justify-content-end mb-3">
				<Button design="btn-secondary btn--small px-3 py-2 rounded-2" onClick={(e) => AgregarPlanificacion(true)}>
					<i className="ico-plus me-2"></i>
					<span>Agregar Planificación </span>
				</Button>
			</div>
			<div className="d-flex flex-column flex-lg-row justify-content-between align-items-lg-center mb-5 gap-3">
			<Formik
				enableReinitialize={true}
				initialValues={initialValues}
				innerRef={formikref}
				onSubmit={values => {
					BuscarEventosConcesion(values);
				}}
			>
				{({ setFieldTouched, setFieldValue, values }) => (
					<Form className="form mb-0">
						<div className="tools order-1 order-lg-0 align-items-start">
							<SelectCheckField
								name="indicador" label="Indicador"
								options={indicadores}								
								value={values.indicador} 
								onBlur={setFieldTouched}
								onChange={(selected, values) => {
								setFieldValue(values);
								setIndicadorSeleccionado(values);
								setExigenciaSeleccionada(-1);
								}}
								isMulti={false}
							/>
							<SelectCheckField
								name="exigencia" label="Exigencia"
								options={exigencias}
								value={values.exigencia}
								onBlur={setFieldTouched}
								onChange={(selected, values) => {
								setFieldValue(values);
								setExigenciaSeleccionada(values);
								}}
								isMulti={false}
							/>
							<OverlayTrigger
								placement="top"
								overlay={
									<Tooltip id="tooltip-top">
										Filtro toma fecha planificada de carga
									</Tooltip>
								}
							>
								<div className="tools order-1 order-lg-0 align-items-start">
									<RangeDatePicker
										startMaxDate={null}
										startMinDate={null}
										endMaxDate={null}
										endMinDate={null}
										name="periodo"
										onChange={(selected, values) => {
											setFieldValue(values);
											setFechaSleccionada(values);
										}}
										onBlur={setFieldTouched}
									/>
								</div>
							</OverlayTrigger>

							<Button type="submit" design="btn-primary">Buscar</Button>
						</div>
					</Form>
				)}
				</Formik>
			</div>
			<div className='accordion-body p-0 brd-top' style={{ overflow: "auto"}}>
				<table className="table table-sm" {...getTableProps()} style={{ width: "100%", borderCollapse: "collapse" }}>
					<thead>
						{headerGroups.map((headerGroup) => {
						const { key: hgKey, ...hgProps } = headerGroup.getHeaderGroupProps();
						return <tr key={hgKey} {...hgProps}>
							{headerGroup.headers.map((column) => {
							const { key, ...restProps } = column.getHeaderProps(
								column.getSortByToggleProps(),
								{ className: column.className }
							);

							return data.length > 0 ? (
								<th key={key} {...restProps}>
								<span className="d-flex align-items-center gap-1">
									{column.render("Header")}
									<>
									{column.isSorted ? (
										column.isSortedDesc && data.length > 0 ? (
										<i className="ico-chevron-down"></i>
										) : (
										<i className="ico-chevron-up"></i>
										)
									) : (
										<>
										<i className="ico-sort fs-7"></i>
										</>
									)}
									</>
								</span>
								</th>
							) : (
								<th key={key} {...restProps}>
								<span className="d-flex align-items-center gap-1">
									{column.render("Header")}
								</span>
								</th>
							);
							})}
							<th className="text-center">Acciones</th>
						</tr>
						})}
					</thead>
					<tbody {...getTableBodyProps()}>
					{
					page.length > 0 && page.map((row) => {
						prepareRow(row);
						const fechaPlanificada = (row.original.fechaPlanificada);

						const fechaPlanificadaObj = new Date(
							fechaPlanificada.split("-").reverse().join("-")
						);

						const fechaHoyObj = new Date(
							fechaHoy.split("-").reverse().join("-")
						);
						
						const existeFechaCarga = row.original.informesConservacion.fechaCarga !== undefined && row.original.informesConservacion.fechaCarga !== null && row.original.informesConservacion.fechaCarga !== '';

						const vencido = (fechaPlanificadaObj <= fechaHoyObj) || existeFechaCarga;
						const icon = vencido ? "ico-doc-search" : "ico-doc-edit";
						const tooltipText = vencido ? "Ver Registro" : "Editar Registro";
						const { key: rowKey, ...rowProps } = row.getRowProps();
						return (
							<tr key={rowKey} {...rowProps}
								onClick={() => handleShow(row.original)}
								style={{ cursor: "pointer" }}
							>
								{row.cells.map((cell) => {
									const cellValue = cell.value === null || cell.value === undefined || cell.value === '' ? '-' : cell.value;
									const { key: tdKey, ...tdProps } = cell.getCellProps({
										className: cell.column.className,
									});
									return (
										<td key={tdKey} {...tdProps}
										>
											{cellValue}
										</td>
									);
								})}
								
								<td className="text-center">
								<OverlayTrigger overlay={<Tooltip id="tooltip-top">{tooltipText}</Tooltip>}>
									<button
										className="link text-pewter-blue fs-4"
										onClick={(e) => {
											e.stopPropagation();
											editarPlanificacion(row.original, existeFechaCarga);
										}}
									>
										<i className={icon}></i>
									</button>
								</OverlayTrigger>
								<OverlayTrigger
										overlay={
											<Tooltip id="tooltip-top">Descargar Formato</Tooltip>
										}
									>
										<button
											className="link text-pewter-blue fs-4"
											onClick={(e) => {
												e.stopPropagation();
												handleButtonClick(row.original);
											}}
										>
											<i className="ico-file-excel"></i>
										</button>
									</OverlayTrigger>
									<OverlayTrigger
										overlay={
											<Tooltip id="tooltip-top">
												Eliminar Planificación
											</Tooltip>
										}
									>
										<button
											className="link text-pewter-blue fs-4"
											onClick={(e) => {
												e.stopPropagation();
												EliminarPlanificacion(row.original);
											}}
											disabled={vencido}
										>
											<i className="ico-close "></i>
										</button>
									</OverlayTrigger>
								</td>
							</tr>
						);
					}) || (
						<tr>
							<td colSpan={headerGroups[0].headers.length + 1}>
								<div className="d-flex justify-content-center align-items-center flex-column gap-2 py-5">
									<img className="mb-3" src={notfound} alt="" />
									<p className="mb-0 text-primary">
										No se encuentran resultados de tu búsqueda.
									</p>
								</div>
							</td>
						</tr>
					)
				}
						
					</tbody>
					
				</table>
			</div>
			{
				page.length > 0 &&
				<PaginationComponent
					pagesCountServer={pageCount}
					currentPage={pageIndex}
					setCurrentPage={gotoPage}
					alwaysShown={true}
					setPagination={setPagination}
				/>
			}
			{
					showModalDescargarArchivo ? 
						<ModalDescargarArchivo
							show={showModalDescargarArchivo}
							onHide={handleClose}
							datosModal={mensajeRespuesta}
						/>
						: null
			}
			{
					showModalMacroubicaciones ?
						<ModalMacroubicaciones
							show={showModalMacroubicaciones}
							onHide={handleClose}
							datosModal={datosModalMacro}
						/>
						: null
				}
		</div>
	);
};


export default PlanificarTable;
